(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider


            .state('supplierPanel.upsertOrderBagNew', {
                parent: 'supplierPanel',
                url: '/new',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            .state('supplierPanel.editOrderBag', {
                parent: 'supplierPanel',
                url: '/{id}/editOrderBag',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/edit-order-bag.html',
                        controller: 'EditOrderBagController',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('orderBagServiceItemDtail');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');


                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagCustom', function ($stateParams, OrderBagCustom) {
                        return OrderBagCustom.getOrderBagWithEntities($stateParams.id).query();
                    }
                    ],
                    invoiceInfoEntity: ['$stateParams', 'InvoiceInfoCustom', function ($stateParams, InvoiceInfoCustom) {
                        return InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query();
                    }]

                }
            })
            .state('supplierPanel.newPaymentLog', {
                parent: 'supplierPanel',
                url: '/newPaymentLog',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog.html',
                        controller: 'OrderBagPaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['$stateParams', function ($stateParams) {
                                return {
                                    traceCode: null,
                                    paymentType: null,
                                    createDate: null,
                                    id: null,
                                    orderBagId: $stateParams.id
                                };
                            }]

                        }
                    }).result.then(function (result) {

                        $state.go('supplierPanel.editOrderBag', {id: result.orderBagId}, {reload: true});
                    }, function (result) {


                    });
                }]
            })


    }

})();
